import React, { useEffect } from "react";
import "../App.scss";
import THREEScene, { LoadGlobals } from "./ThingThree";
import { Link } from "react-router-dom";
import { useTranslation } from "lib/i18n";

function Banner() {
  const { t } = useTranslation();
  const bannerLogo = React.useRef(null);
  useEffect(() => {
    if (!bannerLogo.current) return;
    if (typeof window === "undefined") return;
    const isReactSnap =
      typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
    const prefersReducedMotion =
      typeof window.matchMedia === "function" &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (isReactSnap || prefersReducedMotion || !window.THREE || !window.gsap) {
      return;
    }
    LoadGlobals();
    const scene = new THREEScene(bannerLogo.current);
    scene.onWindowResize();
    return () => {
      scene.destroy();
    }
  }, []);
  return (
    <div className="banner">
      <div className="container">
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6">
            <div className="banner-text text-left mt-4">
              <p className="banner-eyebrow title-font-2">{t("banner.eyebrow")}</p>
              <h1 className="title-font">
                {t("banner.headingPrefix")}{" "}
                <span className="text-customer">Quivio,</span>{" "}
                {t("banner.headingSuffix")}{" "}
                <span className="text-customer">{t("banner.headingEmphasis")}</span>
              </h1>
              <p>{t("banner.subtext")}</p>
              <Link to="/contact" className="btn mt-5 cta-accent" role="button">
                {t("banner.cta")}
              </Link>
              
            </div>
          </div>
          <div className="banner-image col-xl-6 col-lg-6 col-md-6 d-lg-block">
            <div className="banner-area logo-container" ref={bannerLogo} aria-hidden="true">
              {/* <dotlottie-player src="https://lottie.host/0c15e3e2-5bbb-4b87-a156-3710f6301b1c/AUSAmdjPIn.json" background="transparent" speed="1" style="width: 300px; height: 300px;" loop autoplay></dotlottie-player> */}
              {/* <Logo style={
                {
                  maxWidth: "500px",
                  maxHeight: "500px"
              }} /> */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Banner;
